module.exports = __webpack_require__.p + "b97d2f154738d32dd40c899b721b339a.jpg";